<template>
  <div class="hero-container">
    <div class="middle">
      <div class="hero-a">
        <h1 class="hero-title">Josue Omar Tejada</h1>
        <h3 class="hero-description">
          Software Engineer | Full-Stack Developer
        </h3>
      </div>
      <div class="links">
        <div class="linkedin">
          <font-awesome-icon
            icon="fa-brands fa-linkedin"
            size="xl"
            style="color: #ffffff"
          /><a
            href="https://www.linkedin.com/in/josue-o-tejada/"
            target="_blank"
            >Linkedin.com/in/josue-o-tejada</a
          >
        </div>
        <div class="github">
          <font-awesome-icon
            icon="fa-brands fa-github"
            size="xl"
            style="color: #ffffff"
          /><a href="https://github.com/Jdevv96" target="_blank"
            >Github.com/Jdevv96</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroSection",
};
</script>

<style>
.hero-container {
  /* min-height: 100vh; */
  height: 90vh;
}

.hero-title {
  font-size: 5rem;
  font-weight: 600;
  border-bottom: 1px solid white;
  margin-bottom: 0;
  padding-bottom: 20px;
}

.hero-description {
  margin-top: 0;
  padding-top: 20px;
  font-weight: 300;
  font-size: 2rem;
}

.hero-a {
  color: white;
  width: auto;
  height: 600px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.links {
  display: flex;
  justify-content: center;
  align-items: center;
}

.links a {
  text-decoration: none;
  color: white;
  margin: 0 10px;
  font-size: 1.5rem;
  border-bottom: 3px solid transparent;
}

.links a:hover,
.links a:active {
  background-color: #e95420;
  border-bottom-color: rgb(255, 255, 255);
}

.links,
.github {
  margin: 0 30px;
}

.middle {
  margin-top: auto;
  margin-bottom: auto;
}

@media only screen and (max-width: 800px) {
  .hero-title {
    font-size: 3rem;
  }

  .hero-description {
    font-size: 1.5rem;
  }

  .links {
    flex-direction: column;
  }

  .linkedin {
    padding-bottom: 20px;
  }
}

@media only screen and (min-width: 500px) {
  .hero-a {
    height: 400px;
  }
}

@media only screen and (max-width: 500px) {
  .hero-container {
    overflow: hidden;
  }

  .hero-a {
    height: 400px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-description {
    font-size: 1rem;
  }

  .links a {
    font-size: 1rem;
  }
}
</style>
